import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/AdvantageXy/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/FunctionXy/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/HomeXy/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/ProblemXy/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/components/LogXy/index.tsx");
